module.exports = __webpack_public_path__ + "img/image41.5c34176f.png";